import React from "react";

const UserIcon = props => {
    const { fill, classname } = props;

    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill={fill} className={classname}>
            <path d="m7.25 7c0-2.619 2.131-4.75 4.75-4.75s4.75 2.131 4.75 4.75-2.131 4.75-4.75 4.75-4.75-2.131-4.75-4.75zm7.75 6.25h-6c-3.17 0-5.75 2.58-5.75 5.75 0 1.517 1.233 2.75 2.75 2.75h12c1.517 0 2.75-1.233 2.75-2.75 0-3.17-2.58-5.75-5.75-5.75z"></path>
        </svg>
    )
}

export default UserIcon;
